import React from 'react';

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer>
      &copy; {year} Jeremiah Shore, all rights reserved.
    </footer>
  )
};